import script from "./Layout.vue?vue&type=script&lang=ts&setup=true"
export * from "./Layout.vue?vue&type=script&lang=ts&setup=true"

import "./Layout.vue?vue&type=style&index=0&id=7a553488&lang=css"

const __exports__ = script;

export default __exports__